<template>
  <v-card flat>
    <v-card-title class="primary white--text d-flex align-center">
      <span class="headline">Offload Letter / उडानबाट हटाइएको पत्र</span>
      <v-spacer></v-spacer>
      <v-btn icon dark @click="$emit('close')">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text class="pa-6 pa-md-10" id="print-content">
      <div class="letter-content">

        <!-- Header -->
        <div style="margin-bottom: 40px;">
          <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 24px;">
            <div>
            <img src="https://mofaga.gov.np/images/site_logo.png" alt="Nepal Government" height="120" style="margin-right: 32px;">
            </div>
            <div style="line-height: 1.6;margin: 0 auto;text-align: center;">
              <h1 style="font-size: 15px; font-weight: 500; margin: 0; color: #000;">नेपाल सरकार</h1>
              <h1 style="font-size: 18px; font-weight: 600; margin: 0; color: #000;">गृह मन्त्रालय</h1>
              <h2 style="font-size: 20px; font-weight: bold; margin: 8px 0 4px; color: #000;">अध्यागमन कार्यालय, त्रि.अ.वि.</h2>
              <p style="font-size: 14px; font-weight: 700; margin: 0; color: #000;">गौचर, काठमाडौं</p>
            </div>
            <div style="line-height: 1.6;">
              <h1 style="font-size: 14px; margin: 0; color: #000;">इमेल :<span style="margin-left:10px;font-weight: 500;"> tia@immigration .gov.np</span></h1>
              <h1 style="font-size: 14px;  margin: 0; color: #000;">फोन नं. <span style="margin-left:10px;font-weight: 500;"> 01-4113045</span></h1>
            </div>
          </div>

          <div style="display: flex; justify-content: space-between; flex-wrap: wrap; font-size: 15px; margin-top: 30px;">
            <div>
              <div style="margin-bottom:10px;"><strong>पत्र संख्या :</strong> ...................</div>
              <div><strong>चलानी नं :</strong>.................</div>
            </div>
            <div><strong>मिति : </strong>{{getTodayDate()}}</div>
          </div>
        </div>

        <hr style="border: none; margin: 30px 0;">

        <!-- Subject -->
        <div style="text-align: center; margin-bottom: 40px;">
          <h2 style="font-size: 18px; font-weight: bold; margin: 0;text-decoration: underline;">
            विषय: प्रस्थान अनुमति नदिएको सम्बन्धमा।
          </h2>
        </div>

        <!-- Body Text -->
        <div style="font-size: 16px; line-height: 2.1; text-align: justify; margin-bottom: 30px;">
          <p style="margin: 0 0 24px 0;">
            अध्यागमन ऐन, २०४९, अध्यागमन नियमावली, २०५१ तथा अध्यागमन कार्यविधि, २०६५ अनुसार देहायका कारणले तपाईंलाई प्रस्थान अनुमति नदिइएको व्यहोरा जानकारीका लागि अनुरोध छ ।
          </p>

          <table style="width: 100%; margin: 30px 0; border-collapse: collapse; font-size: 17px;">
            <tr><td style="width: 38%; padding: 8px 0; font-weight: 500;">नाम थर </td><td style="font-weight: 600;">: {{ traveller.name }}</td></tr>
            <tr><td style="padding: 8px 0; font-weight: 500;">राष्ट्रियता </td><td style="font-weight: 600;">: {{ traveller.nationality }}</td></tr>
            <tr><td style="padding: 8px 0; font-weight: 500;">ठेगाना </td><td style="font-weight: 600;">: {{ traveller.nationality }}</td></tr>
            <tr><td style="padding: 8px 0; font-weight: 500;">राहदानी नं/नागरिकता नं.</td><td style="font-weight: 600;">: {{ traveller.passport }}</td></tr>
            <tr><td style="padding: 8px 0; font-weight: 500;">उडान नं</td><td style="font-weight: 600;">: {{ traveller.flight_number }}</td></tr>
            <tr><td style="padding: 8px 0; font-weight: 500;">गन्तव्य मुलुक</td><td style="font-weight: 600;">: {{ traveller.destination }}</td></tr>
            <tr><td style="padding: 8px 0; font-weight: 500;">कारण</td><td style="font-weight: 600;">: {{ traveller.reason }}</td></tr>
          </table>

        </div>

        <!-- Signature -->
        <div style="margin-top: 80px; text-align: right;">
          <div style="width: 260px; margin-left: auto; margin-bottom: 8px;"></div>
          <p style="margin: 4px 0 0 0; font-size: 14px; color: #333;">..................................</p>
          <p style="margin: 0; font-weight: 500; font-size: 16px;">{{traveller.officer}}</p>
        </div>

        <!-- Footer -->
        <div style="text-align: left; margin-top: 10px; padding-top: 20px;">
          <p style="margin: 0; font-size: 16px; color: #555;">
            बोधार्थः
          </p>
          <p style="margin: 4px 0 0 0; font-size: 14px; color: #333;">श्री {{traveller.airline_name}}   त्रि.अ.वि., गौचर, काठमाडौं</p>
        </div>
      </div>
    </v-card-text>

    <v-card-actions class="pa-4 justify-end" style="background:#f5f5f5;">
      <v-btn color="red darken-2" dark @click="$emit('close')">Cancel</v-btn>
      <v-btn color="primary" dark @click="printLetter">
        <v-icon left>mdi-printer</v-icon>
        Print Letter
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import axios from 'axios';
import { API_URL, VERSION } from "../../../config/config";

export default {
  props: {
    traveller: { type: Object, required: true },
    flightNumber: { type: String, required: true },
    airlineName: { type: String, required: true },
    date: { type: [String, Date], required: true },
    nepaliDate: { type: String, required: true }
  },

  computed: {
    formattedDate() {
      if (!this.date) return '';
      const d = new Date(this.date);
      return d.toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' }).split('/').join('-');
    }
  },

  methods: {
    getTodayDate() {
      const today = new Date();
      return today.getFullYear() + '-' +
          String(today.getMonth() + 1).padStart(2, '0') + '-' +
          String(today.getDate()).padStart(2, '0');
    },
    async generateReport() {
      try {
        await axios.post(`${API_URL}${VERSION}/offload-report/offload-letter-generated`, {
          traveller_id: this.traveller.id,
        });
      } catch (error) {
        console.error('Failed to generate offload report:', error);
      }
    },

    async printLetter() {
      await this.generateReport();

      const content = document.getElementById('print-content').innerHTML;

      const printWindow = window.open('', '', 'width=1000,height=800');

      printWindow.document.write(`
<!DOCTYPE html>
<html>
<head>
  <meta charset="UTF-8">
  <title>Offload Letter - Nepal Immigration</title>
  <style>
    body, html {
      margin: 0; padding: 0; height: 297mm; width: 210mm;
      font-family: Arial, sans-serif !important;
      background: white; color: #000;
    }
    .page {
      width: 210mm; min-height: 297mm; padding: 15mm; box-sizing: border-box;
      margin: 0 auto; background: white;
    }
    @page { size: A4; margin: 0; }
    @media print {
      body, html { width: 210mm; height: 297mm; margin: 0 !important; padding: 0 !important; }
      .page { padding: 15mm !important; margin: 0 !important; page-break-after: avoid; }
    }
  </style>
</head>
<body>
  <div class="page">
    ${content}
  </div>
</body>
</html>
      `);

      printWindow.document.close();
      printWindow.focus();

      printWindow.onload = () => {
        setTimeout(() => {
          printWindow.print();
          // printWindow.close(); // Uncomment if you want auto-close after print
        }, 800);
      };
    }
  }
}
</script>